import { TaskManager } from "constants/Actions";
import { IAPIAction } from "interfaces";

const {
  GET_GROUPS,
  GET_GROUPS_FAIL,
  GET_GROUPS_SUCCESS,
  GET_PENDING_TASKS,
  GET_PENDING_TASKS_FAIL,
  GET_PENDING_TASKS_SUCCESS,
  GET_TASKS,
  GET_TASKS_FAIL,
  GET_TASKS_SUCCESS,
  MANAGE_TASK_DRAWER,
  CREATE_GROUP,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_FAIL,
  UPDATE_GROUP,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_FAIL,
  GET_TASK_HISTORY,
  GET_TASK_HISTORY_FAIL,
  GET_TASK_HISTORY_SUCCESS,
  GET_INSTANCE_HISTORY,
  GET_INSTANCE_HISTORY_FAIL,
  GET_INSTANCE_HISTORY_SUCCESS,
  SAVE_TASK_INSTANCE,
  SAVE_TASK_INSTANCE_FAIL,
  SAVE_TASK_INSTANCE_SUCCESS,
  GET_OPERATIONS_HANDLERS,
  GET_OPERATIONS_HANDLERS_FAIL,
  GET_OPERATIONS_HANDLERS_SUCCESS,
  DELETE_GROUP,
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  CREATE_TASK,
  CREATE_TASK_SUCCESS,
  CREATE_TASK_FAIL,
  UPDATE_TASK,
  UPDATE_TASK_SUCCESS,
  UPDATE_TASK_FAIL,
  SEND_EMAIL,
  SEND_EMAIL_FAIL,
  SEND_EMAIL_SUCCESS,
  RUN_TASK,
  RUN_TASK_SUCCESS,
  RUN_TASK_FAIL,
  DELETE_TASK,
  DELETE_TASK_SUCCESS,
  DELETE_TASK_FAIL,
  GET_SCRIPTS,
  GET_SCRIPTS_SUCCESS,
  GET_SCRIPTS_FAIL,
} = TaskManager;

export const taskManager: Readonly<IAPIAction> = {
  groups: {
    get: (data) => ({
      type: GET_GROUPS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    delete: (data) => ({
      type: DELETE_GROUP,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_GROUPS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_GROUPS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  pendingTasks: {
    get: (data) => ({
      type: GET_PENDING_TASKS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_PENDING_TASKS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_PENDING_TASKS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  tasks: {
    get: (data) => ({
      type: GET_TASKS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_TASKS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_TASKS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    openDrawer: (data) => ({
      type: MANAGE_TASK_DRAWER,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  newGroup: {
    save: (data) => ({
      type: CREATE_GROUP,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: CREATE_GROUP_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: CREATE_GROUP_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  group: {
    update: (data) => ({
      type: UPDATE_GROUP,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: UPDATE_GROUP_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: UPDATE_GROUP_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  taskHistory: {
    get: (data) => ({
      type: GET_TASK_HISTORY,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_TASK_HISTORY_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_TASK_HISTORY_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  instanceHistory: {
    get: (data) => ({
      type: GET_INSTANCE_HISTORY,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_INSTANCE_HISTORY_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_INSTANCE_HISTORY_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  taskInstance: {
    save: (data) => ({
      type: SAVE_TASK_INSTANCE,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SAVE_TASK_INSTANCE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SAVE_TASK_INSTANCE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  operationsHandlers: {
    get: (data) => ({
      type: GET_OPERATIONS_HANDLERS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_OPERATIONS_HANDLERS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_OPERATIONS_HANDLERS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  users: {
    get: (data) => ({
      type: GET_USERS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_USERS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_USERS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  task: {
    save: (data) => ({
      type: CREATE_TASK,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: CREATE_TASK_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: CREATE_TASK_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  updateTask: {
    save: (data) => ({
      type: UPDATE_TASK,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: UPDATE_TASK_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: UPDATE_TASK_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  email: {
    save: (data) => ({
      type: SEND_EMAIL,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SEND_EMAIL_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SEND_EMAIL_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  taskRun: {
    get: (data) => ({
      type: RUN_TASK,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: RUN_TASK_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: RUN_TASK_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  taskDelete: {
    save: (data) => ({
      type: DELETE_TASK,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: DELETE_TASK_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: DELETE_TASK_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  scripts: {
    get: (data) => ({
      type: GET_SCRIPTS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_SCRIPTS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_SCRIPTS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
